module.exports = __webpack_public_path__ + "assets/img/left-title-open-3abc5679.png";